export default {
    // 微信应用
    WECHAT_APPLICATION: "微信应用",
    WECHAT_APPLICATION_CREATE: "新建微信应用",
    WECHAT_APPLICATION_CREATE_SUCCESS: "新建微信应用成功",
    WECHAT_APPLICATION_UPDATE: "更新微信应用",
    WECHAT_APPLICATION_UPDATE_SUCCESS: "更新微信应用成功",
    WECHAT_APPLICATION_NAME: "名称",
    WECHAT_APPLICATION_NAME_REQUIRED: "微信应用名称不能为空",
    WECHAT_APPLICATION_APP_ID: "应用ID",
    WECHAT_APPLICATION_APP_ID_REQUIRED: "微信应用ID不能为空",
    WECHAT_APPLICATION_APP_SECRET: "应用Secret",
    WECHAT_APPLICATION_APP_SECRET_REQUIRED: "微信应用Secret不能为空",
    WECHAT_APPLICATION_TYPE: "类型",
    WECHAT_APPLICATION_TYPE_OFFICIAL: "公众号",
    WECHAT_APPLICATION_TYPE_APPLET: "小程序",
    WECHAT_APPLICATION_TYPE_REQUIRED: "微信应用类型不能为空",

    // 微信模版
    WECHAT_MESSAGE_TEMPLATE: "微信模版",
    WECHAT_MESSAGE_TEMPLATE_CREATE: "新建微信模版",
    WECHAT_MESSAGE_TEMPLATE_CREATE_SUCCESS: "新建微信模版成功",
    WECHAT_MESSAGE_TEMPLATE_UPDATE: "更新微信模版",
    WECHAT_MESSAGE_TEMPLATE_UPDATE_SUCCESS: "更新微信模版成功",
    WECHAT_MESSAGE_TEMPLATE_APPLICATION_ID: "所属应用",
    WECHAT_MESSAGE_TEMPLATE_APPLICATION_ID_REQUIRED: "请选择所属应用",
    WECHAT_MESSAGE_TEMPLATE_CODE: "编号",
    WECHAT_MESSAGE_TEMPLATE_CODE_REQUIRED: "微信模版编号不能为空",
    WECHAT_MESSAGE_TEMPLATE_NAME: "名称",
    WECHAT_MESSAGE_TEMPLATE_NAME_REQUIRED: "微信模版名称不能为空",
    WECHAT_MESSAGE_TEMPLATE_TEMPLATE_ID: "微信模板Id",
    WECHAT_MESSAGE_TEMPLATE_TEMPLATE_ID_REQUIRED: "请填写微信模板Id",
    WECHAT_MESSAGE_TEMPLATE_TEMPLATE_TITLE: "微信模板标题",
    WECHAT_MESSAGE_TEMPLATE_TEMPLATE_TITLE_REQUIRED: "请填写微信模板标题",
    WECHAT_MESSAGE_TEMPLATE_TEMPLATE_KEYWORD1: "关键字1",
    WECHAT_MESSAGE_TEMPLATE_TEMPLATE_KEYWORD2: "关键字2",
    WECHAT_MESSAGE_TEMPLATE_TEMPLATE_KEYWORD3: "关键字3",
    WECHAT_MESSAGE_TEMPLATE_TEMPLATE_KEYWORD4: "关键字4",
    WECHAT_MESSAGE_TEMPLATE_TEMPLATE_KEYWORD5: "关键字5",
    WECHAT_MESSAGE_TEMPLATE_PAGE_URL: "跳转URL",
};
